import React from "react"
import { Typography } from "@material-ui/core"

import useStyles from "@/pages/Attendance/Chat/ConversationPanel/MessageList/FlowResponseContent/styles"

type FlowResponseHeaderProps = {
	name?: string
}

const FlowResponseHeader: React.FC<FlowResponseHeaderProps> = (props) => {
	const { name } = props

	const classes = useStyles()

	return (
		<Typography variant="overline" className={classes.flowResponseHeaderText}>
			<strong>Formulário:</strong>{name ? ` ${name}` : ""}
		</Typography>
	)
}

export default FlowResponseHeader
